<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <el-row>
        <selectStandardId @updateStandardId="updateStandardId" />
        <el-select
          v-model="classType"
          clearable
          filterable
          class="w-200px ml-10px"
          placeholder="解析实体"
          size="small"
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="taskName"
          clearable
          class="w-200px ml-10px mr-10px"
          placeholder="任务名称"
          size="small"
        ></el-input>
        <el-button type="primary" @click="searchTableData">{{ $t('search') }}</el-button>
        <el-button type="primary" :disabled="!$hasAccess('create')" @click="addTask">{{
          $t('new')
        }}</el-button>
        <el-button type="danger" :disabled="!$hasAccess('delete')" @click="delTask(idList)">{{
          $t('delete')
        }}</el-button>
        <!-- <el-button :disabled="!$hasAccess('export')">{{ $t('export') }}</el-button>
        <el-button :disabled="!$hasAccess('import')">{{ $t('import') }}</el-button> -->
      </el-row>
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        border
        class="mt-20px"
        height="calc(100% - 104px)"
        :highlight-current-row="true"
        @selection-change="selectionChange"
        @sort-change="sortChange"
        stripe
        ref="table"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="55"></el-table-column>
        <el-table-column prop="taskName" label="任务名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="modelName" label="模型名称" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="standardName"
          label="参照标准"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="className" label="解析实体" show-overflow-tooltip></el-table-column>
        <el-table-column
          prop="classAttributeName"
          label="解析属性"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="lastModifiedTime"
          label="修改时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" fixed="right" width="250">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="manualExecution(scope.row.id)"
              :disabled="!$hasAccess('manualExecution')"
              >手动执行</el-button
            >
            <el-button size="mini" @click="editTask(scope.row)" :disabled="!$hasAccess('update')">{{
              $t('edit')
            }}</el-button>
            <el-button
              size="mini"
              @click="delTask([scope.row.id])"
              :disabled="!$hasAccess('delete')"
              >{{ $t('delete') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="mt-20px float-right">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新建 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="addVisiable"
      class="small-dialog"
      :close-on-click-modal="false"
      v-dialogDrag
      @close="closeBaseFormDialog"
    >
      <el-form ref="baseForm" label-width="150px" :model="form" :rules="rules">
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="form.taskName" placeholder="请输入" clearable class="w-full">
          </el-input>
        </el-form-item>
        <el-form-item label="模型名称" prop="modelName">
          <el-input
            v-model="form.modelName"
            :placeholder="`${$t('pleaseSelect')}`"
            clearable
            class="w-full can-not-input"
            @clear="clearModelName"
          >
            <el-button
              slot="append"
              icon="iconfont icon-line-seach"
              @click="modelVisiable = true"
            ></el-button>
          </el-input>
        </el-form-item>
        <el-form-item label="参照标准" prop="standardId">
          <el-select
            v-model="form.standardId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择标准"
            size="small"
            @change="changeStandardId"
          >
            <el-option
              v-for="item in standardList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主题">
          <el-select
            v-model="form.subjectDomainId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择主题"
            size="small"
            @change="changeThemeId"
          >
            <el-option
              v-for="item in themeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析实体" prop="classId">
          <el-select
            v-model="form.classId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择实体"
            size="small"
            @change="changeClassId"
          >
            <el-option
              v-for="item in classList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="解析字段" prop="classAttributeId">
          <el-select
            v-model="form.classAttributeId"
            clearable
            filterable
            class="w-full"
            placeholder="请选择属性"
            size="small"
          >
            <el-option
              v-for="item in attributeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="closeBaseFormDialog">{{ `${$t('Cancel')}` }}</el-button>
        <el-button type="primary" @click="submitBaseForm">{{ `${$t('save')}` }}</el-button>
      </div>
    </el-dialog>

    <!-- 选择模型 -->
    <selectModel
      :modelVisiable="modelVisiable"
      @updateModelData="updateModelData"
      @closeModelDialog="closeModelDialog"
    />
  </div>
</template>

<script>
import assetService from '@/services/assetService'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import StdSubjectDomainService from '@/services/bsApi/StdSubjectDomainService'
import stdClassListService from '@/services/stdClassListService'
import ModelParsingTaskService from '@/services/ModelParsingTaskService'
import selectStandardId from '../../components/selectStandardId'
import selectModel from './components/selectModel'

export default {
  name: 'ModelParseTasks',
  components: { selectStandardId, selectModel },
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      standardList: [],
      classTypeList: [],
      classType: '',
      taskName: '',
      tableData: [],
      tableLoading: false,
      selectionList: [],
      idList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      addVisiable: false,
      form: {
        taskName: '',
        modelName: '',
        models: '',
        standardId: '',
        subjectDomainId: '',
        classId: '',
        classAttributeId: '',
        id: '',
      },
      rules: {
        taskName: [{ required: true, message: '请输入任务名称', trigger: 'blur' }],
        modelName: [{ required: true, message: '请选择模型名称', trigger: 'blur' }],
        standardId: [{ required: true, message: '请选择标准', trigger: 'blur' }],
        classId: [{ required: true, message: '请选择实体', trigger: 'blur' }],
        classAttributeId: [{ required: true, message: '请选择属性', trigger: 'blur' }],
      },
      modelVisiable: false,
      themeList: [],
      classList: [],
      attributeList: [],
      dialogTitle: '',
    }
  },
  watch: {
    standardId(newVal) {
      if (newVal) {
        this.getClassTypeList()
        this.searchTableData()
      }
    },
    classType() {
      this.searchTableData()
    },
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
    },
    // 获取实体列表
    async getClassTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1,
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
    },
    selectionChange(val) {
      this.selectionList = val
      this.idList = _.map(val, (item) => {
        return item.id
      })
    },
    sortChange() {},
    delTask(ids) {
      if (ids.length > 0) {
        this.$confirm('是否确定要删除该解析任务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await ModelParsingTaskService.deleteModelParsingTask(ids)
          if (res) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.info('请选择要删除的数据')
      }
    },
    addTask() {
      this.dialogTitle = '新建解析任务'
      this.addVisiable = true
      this.standardList = localStorage.getItem('standardList')
        ? JSON.parse(localStorage.getItem('standardList'))
        : ''
      this.form.standardId = this.standardId
      this.changeStandardId()
    },
    editTask(row) {
      _.assign(
        this.form,
        _.pick(row, [
          'taskName',
          'modelName',
          'standardId',
          'classId',
          'subjectDomainId',
          'classAttributeId',
          'id',
        ])
      )
      this.form.models = _.map(row.modelTaskRelations, (item) => {
        return {
          modelId: item.modelId,
          modelName: item.modelName,
        }
      })
      this.dialogTitle = '编辑解析任务'
      this.addVisiable = true
      this.standardList = localStorage.getItem('standardList')
        ? JSON.parse(localStorage.getItem('standardList'))
        : ''
      this.getThemeList()
      this.getClassList()
      this.getAttrList()
    },
    handleSizeChange(pageSize) {
      this.page.pageSize = pageSize
      this.searchTableData()
    },
    handleCurrentChange(pageNo) {
      this.page.pageNo = pageNo
      this.searchTableData()
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await ModelParsingTaskService.getModelParsingTaskList({
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        standardId: this.standardId,
        filter: this.taskName,
        classId: this.classType,
      })
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.tableData = _.map(res.data, (item) => {
          item.modelName = _.map(item.modelTaskRelations, (mItem) => {
            return mItem.modelName
          })
          item.modelName = item.modelName.join(',')
          return item
        })
        this.page.total = res.totalCount
      } else {
        this.tableData = []
        this.page.total = 0
      }
    },
    clearModelName() {
      this.form.modelName = ''
    },
    // 修改参照标准
    changeStandardId() {
      this.form.subjectDomainId = ''
      this.form.classId = ''
      this.form.classAttributeId = ''
      this.getThemeList()
      this.getClassList()
    },
    changeThemeId() {
      this.form.classId = ''
      this.form.classAttributeId = ''
      this.getClassList()
    },
    changeClassId() {
      this.form.classAttributeId = ''
      this.getAttrList()
    }, // 获取主题列表
    async getThemeList() {
      const parameter = {
        standard_id: this.form.standardId,
        pageno: 1,
        pagesize: 999,
      }
      const res = await StdSubjectDomainService.list(parameter)
      if (res && res.code === 0 && res.data) {
        this.themeList = _.sortBy(res.data, (item) => {
          return item.seqNo
        })
      }
    },
    // 获取实体列表
    async getClassList() {
      const parameter = {
        data_type: 1,
        standard_id: this.form.standardId,
        subject_domain_id: this.form.subjectDomainId,
        approve_status: 1, // 已发布
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classList = res.data
      }
    },
    // 获取属性列表
    async getAttrList() {
      const res = await assetService.getClassAndClassTypeAttrDropDowData({
        classId: this.form.classId,
        skipCount: 0,
        maxResultCount: 999,
        sorting: '',
        nameOrCode: '',
      })
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data
      }
    },
    closeBaseFormDialog() {
      this.$refs.baseForm.resetFields()
      this.form = this.$options.data().form
      this.addVisiable = false
    },
    // 保存
    submitBaseForm() {
      this.$refs.baseForm.validate(async (valid) => {
        if (valid) {
          if (this.form.id) {
            const res = await ModelParsingTaskService.updateModelParsingTask(this.form)
            if (res && res.code === 0) {
              this.$message.success('修改成功')
              this.searchTableData()
              this.closeBaseFormDialog()
            }
          } else {
            const res = await ModelParsingTaskService.addModelParsingTask(this.form)
            if (res && res.code === 0) {
              this.$message.success('新增成功')
              this.searchTableData()
              this.closeBaseFormDialog()
            }
          }
        }
      })
    },
    updateModelData(data) {
      const modelName = _.map(data, (item) => {
        return item.name
      })
      this.form.modelName = modelName.join(',')
      this.form.models = _.map(data, (item) => {
        return {
          modelId: item.id,
          modelName: item.name,
        }
      })
    },
    closeModelDialog() {
      this.modelVisiable = false
    },
    async manualExecution(id) {
      const res = await ModelParsingTaskService.manualExecution(id)
      if (res && res.code === 0) {
        this.$message.success('手动执行成功')
        this.searchTableData()
      }
    },
  },
  created() {
    this.getClassTypeList()
    this.searchTableData()
  },
  activated() {
    this.standardId = localStorage.getItem('standardId')
  },
}
</script>

<style lang="scss" scoped>

.can-not-input {
  ::v-deep input {
    pointer-events: none;
  }
}

</style>
